export const championshipLeagues = ['PGA', 'WTA', 'ATP', 'Horse Racing'];
